<template>
	<div>
		<v-dialog v-model="dialog_gst" no-click-animation persistent content-class="full-height" scrollable transition="dialog-bottom-transition">
	      <v-card>
	        <v-card-title noshadow class="dialog_searchbox">
        		<v-subheader full-width>GST Details</v-subheader>
        	</v-card-title>

	        <v-divider></v-divider>

	        <v-card-text dialog-card-content>
	            <v-layout wrap>

	              	<v-form data-vv-scope="fields" full-width>

			        	<v-flex xs12 sm12 md12 form-item @click="openDialogGstTypes">
			               	<v-text-field  
			               		readonly 
			               		v-model="$parent.Form.selectedGstType" 
			               		label="Select GST Type" 
			               		placeholder=" " 
			               		append-icon="arrow_drop_down"
			               		v-validate="'required'" 
			               		name="gstType"
			               		data-vv-name="gstType" 
			               		:error-messages="errors.collect('fields.gstType')"
			               		required>
			               	</v-text-field>

			            </v-flex>

			            <v-flex xs12 sm12 md12 form-item @click="openStates('ref_dialogGstDetails_placeOfSupply')" v-if="$parent.Form.accountGstFieldTemp.gstType!=105">

			               <v-text-field  
			               		readonly
			               		v-model="$parent.Form.accountGstFieldTemp.placeOfSupply" 
			               		label="State/Place of Supply" 
			               		placeholder=" "
			               		append-icon="arrow_drop_down"
			               		ref="ref_dialogGstDetails_placeOfSupply" 
				               	:onUpdate="updatePlaceOfSupply"
				               	v-validate="'required'" 
				               	name="PlaceofSupply"
				               	data-vv-name="PlaceofSupply"
				               	:error-messages="errors.collect('fields.PlaceofSupply')" 
				               	required>
				               	<!-- v-validate="'required'" 
				               	name="PlaceofSupply"
				               	data-vv-name="PlaceofSupply"
				               	:error-messages="errors.collect('fields.PlaceofSupply')" 
				               	required -->
			               	</v-text-field>
			            </v-flex>

			            <!-- <v-flex xs12 sm12 md12 form-item v-if="$parent.Form.accountGstFieldTemp.gstType==101 || $parent.Form.accountGstFieldTemp.gstType==102 || $parent.Form.accountGstFieldTemp.gstType==106 || $parent.Form.accountGstFieldTemp.gstType==107" >
			               <v-text-field 
			               		uppercase  
			               		label="GST Number (GSTIN)" 
			               		:hide-details="!errors.has('fields.GSTNumber')"
			               		placeholder=" " 
			               		v-model="$parent.Form.accountGstFieldTemp.gstNumber" 
			               		v-validate="'required|nospace|min:15|max:15'"
			               		name="GSTNumber" 
			               		data-vv-name="GSTNumber" 
			               		:error-messages="errors.collect('fields.GSTNumber')">
			               	</v-text-field>
			               	<div class="pt-1" right-align font12 light-opacity-color>Example: 12ABCDE1234A9Z9</div>
			            </v-flex> -->

			            <v-flex xs12 sm12 md12 form-item v-if="$parent.Form.accountGstFieldTemp.gstType==101 || $parent.Form.accountGstFieldTemp.gstType==102 || $parent.Form.accountGstFieldTemp.gstType==106 || $parent.Form.accountGstFieldTemp.gstType==107">
			               <v-text-field 
			               		uppercase  
			               		label="GST Number (GSTIN)" 
			               		:hide-details="!errors.has('fields.GSTNumber')"
			               		placeholder=" " 
			               		v-model="$parent.Form.accountGstFieldTemp.gstNumber" 
			               		v-validate="'required|verify_gstnumber'"
			               		name="GSTNumber" 
			               		data-vv-name="GSTNumber" 
			               		:error-messages="errors.collect('fields.GSTNumber')">
			               	</v-text-field>
			               	<div class="pt-1" right-align font12 light-opacity-color>Example: 12ABCDE1234A9Z9</div>
			            </v-flex>

			            <v-flex xs12 sm12 md12 form-item v-if="$parent.Form.accountGstFieldTemp.gstType!=105">
			               <v-text-field 
			               		uppercase  
			               		label="PAN No" 
			               		placeholder=" " 
			               		v-model="$parent.Form.accountGstFieldTemp.panNumber"
			               		v-validate="'verify_pannumber'" 
			               		name="PanNumber"
			               		data-vv-name="PanNumber"
			               		:error-messages="errors.collect('fields.PanNumber')">
			               	</v-text-field>
			               	<!-- <span style="font-size:small">e.g. ABCDE1234A</span> -->
			            </v-flex>

						<!-- <v-flex xs12 sm12 md12 form-item v-if="$parent.Form.accountGstFieldTemp.gstType==103 && $parent.Form.groupTypeId == 102">
			               <v-text-field 
			               		type="number"
			               		label="Aadhar Number" 
			               		placeholder=" " 
			               		v-model="$parent.Form.accountGstFieldTemp.aadharNumber">
			               	</v-text-field>
			            </v-flex> -->

			            <v-flex xs12 sm12 md12 form-item>

			               <v-text-field  
			               		@click="openCountries('ref_dialogGstDetails_country', 'gst')" v-if="$parent.Form.accountGstFieldTemp.gstType==105"
			               		readonly
			               		v-model="$parent.Form.accountGstFieldTemp.country" 
			               		label="Select Country" 
			               		placeholder=" "
			               		append-icon="arrow_drop_down"
			               		ref="ref_dialogGstDetails_country" 
				               	:onUpdate="updateOverseasCountry"
				               	v-validate="'required'" 
			               		name="country"
			               		data-vv-name="country"
			               		:error-messages="errors.collect('fields.country')"
			               		required>
			               	</v-text-field>
			               	
			            </v-flex>

			            <!-- <v-flex xs12 sm12 md12 form-item>
			               <v-text-field  label="Currency" v-if="$parent.Form.accountGstFieldTemp.gstType==105"
			               		placeholder=" " 
			               		v-model="$parent.Form.accountGstFieldTemp.currency"
			               		v-validate="'required'" 
			               		name="Currency"
			            		data-vv-name="Currency" 
			            		:error-messages="errors.collect('fields.Currency')" 
			            		required>
			               	</v-text-field>
			            </v-flex> -->
	              	</v-form>

	            </v-layout>

	        </v-card-text>

	        <v-divider></v-divider>

	        <v-card-actions>
	          <v-spacer></v-spacer>
	          <v-btn color="blue darken-1" flat @click="$parent.fn_closeDialog">close</v-btn>
	          <v-btn color="blue darken-1" flat @click="fn_checkValidations('setdetails')">Done</v-btn>
	        </v-card-actions>
	      </v-card>
	    </v-dialog>
	</div>
</template>

<script>
export default{
	// props:['openDialogGstTypes', 'openStates', 'updatePlaceOfSupply', 'post', 'openDialogGstDetails', 'checkAndUpdateGstType', 'openCountries', 'updateOverseasCountry'],
	props:['openDialogGstTypes', 'openStates', 'updatePlaceOfSupply', 'checkAndUpdateGstType', 'openCountries', 'updateOverseasCountry'],
	data(){	
		return{
			dialog_gst: false,
		}
	},
	methods:{
		openDialogWeb: function () {	
			this.errors.clear('fields');
			this.dialog_gst = true;
			// this.$refs.ref_gstNumber.$el.querySelector("input").addEventListener("paste", val=>{
			// 	// this.fn_trimGstNumber(val);
			// 	setTimeout(() => {
			// 		this.$parent.Form.accountGstFieldTemp.gstNumber = this.$parent.Form.accountGstFieldTemp.gstNumber.split(" ").join("");	
			// 		this.$forceUpdate();
			// 		this.errors.remove('fields.GSTNumber');
			// 	}, 300);
			// });
		},
		closeDialogWeb: function () {
			this.dialog_gst = false;
		},
		// fn_trimGstNumber: function(val){
		// 	if(val){
		// 		this.$parent.Form.accountGstFieldTemp.gstNumber = val.split(" ").join("");	
		// 		this.$forceUpdate();
		// 		this.errors.remove('fields.GSTNumber');
		// 	}
		// },
		fn_checkValidations: function (type) {
			if(this.$parent.Form.accountGstFieldTemp.gstType==101 || this.$parent.Form.accountGstFieldTemp.gstType==102 || this.$parent.Form.accountGstFieldTemp.gstType==106 || this.$parent.Form.accountGstFieldTemp.gstType==107){
				this.$parent.Form.accountGstFieldTemp.gstNumber = this.$parent.Form.accountGstFieldTemp.gstNumber.split(" ").join("");	
				this.errors.remove('fields.GSTNumber');
			}

			this.$validator.validateAll('fields').then((result) => {
				result ? this.checkAndUpdateGstType(this.$parent.Form.accountGstFieldTemp) : '';
		        // if(type=='saveall'){
		        // 	result ? this.post() : this.openDialogGstDetails();
		        // }
		        // else{
		        // 	result ? this.checkAndUpdateGstType(this.$parent.Form.accountGstFieldTemp) : '';
		        // }
		    });
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/components/masters/forms/ledgers/dialogs/dialog_gst_details.vue